export const SimmerCardStyles = {
    cardHead:{
        padding:"0px 0px 16px 0px",
    },
    
    }